module.exports = __webpack_public_path__ + "static/media/logo_normal.c6cb749e.svg";